import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
import {connectFunctionsEmulator, getFunctions} from 'firebase/functions';
import {FirebaseOptions, initializeApp} from 'firebase/app';
import {env} from '../constants';

export const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyDq4q-SBRSh3lAojGvSMBhjRYRrEn4vWO4',
  authDomain: 'etsy-d5e0c.firebaseapp.com',
  projectId: 'etsy-d5e0c',
  storageBucket: 'etsy-d5e0c.appspot.com',
  messagingSenderId: '463048729168',
  appId: '1:463048729168:web:2fe8b65cb24f74a69b6755',
  measurementId: 'G-B09R0KPZWB',
};

export const firebaseConfigStage: FirebaseOptions = {
  apiKey: 'AIzaSyAL_5eWFnjxYaGf6p3QlaVNK2PwKJVWlNA',
  authDomain: 'crafty-smile-staging.firebaseapp.com',
  projectId: 'crafty-smile-staging',
  storageBucket: 'crafty-smile-staging.firebasestorage.app',
  messagingSenderId: '273322495402',
  appId: '1:273322495402:web:1bb4817fa359db4f3b6fd3',
  measurementId: 'G-8XMMQXQ90R',
};

export const firebaseConfigProd: FirebaseOptions = {
  apiKey: 'AIzaSyBoOU8Dfnzx7yLMpU53sI2IOpXvwVH6PZE',
  authDomain: 'crafty-smile.firebaseapp.com',
  projectId: 'crafty-smile',
  storageBucket: 'crafty-smile.firebasestorage.app',
  messagingSenderId: '992135342121',
  appId: '1:992135342121:web:24bdff70bbb0afd0ef9438',
  measurementId: 'G-67CXH24CBK',
};

const firebaseApp = initializeApp(env.isProduction ? firebaseConfigProd : firebaseConfigStage);

export const firebaseAuth = getAuth(firebaseApp);
export const firebaseFirestore = getFirestore(firebaseApp);

// // Lazy-init Firestore on first use so we never call getFirestore at module load.
// // Calling it at load time can throw "Service firestore is not available" when
// // the app is split across chunks (multiple Firebase SDK instances).
// let firestoreInstance: ReturnType<typeof getFirestore> | null = null;
// export function getFirebaseFirestore() {
//   if (firestoreInstance === null) {
//     firestoreInstance = getFirestore(firebaseApp);
//   }
//   return firestoreInstance;
// }
export const firebaseFunction = getFunctions(firebaseApp, 'europe-west2');

if (env.isDevelopment) {
  console.info('using emulator');
  connectFunctionsEmulator(firebaseFunction, 'localhost', 15001);
}

export function getFirebaseFunction(path?: string) {
  if (env.isDevelopment) {
    // @ts-ignore
    const s: string[] = [
      (firebaseFunction as any).emulatorOrigin as string,
      firebaseApp.options.projectId as string,
      firebaseFunction.region,
      ...(path ? [path] : []),
    ];
    return s.join('/');
  }
  // @ts-ignore
  // return `https://${firebaseFunction.region}-${firebaseApp.options.projectId as string}.cloudfunctions.net/${path}`;
  return `/${path}`;
}
